import './assets/main.css'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'jsvectormap/dist/jsvectormap.css'
import 'flatpickr/dist/flatpickr.css'

// Import Plugins
import { mercureTopicChannel } from 'fungi-types'
import MercurePlugin from '@/plugins/mercure'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueApexCharts from 'vue3-apexcharts'

// Import the Toast component
import Toast, { PluginOptions } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

const app = createApp(App)

const options: PluginOptions = {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
  containerClassName: 'custom-toast-container',
}

app.use(router)
app.use(Toast, options)
app.use(VueApexCharts)
// Install Mercure plugin with optional auto-connect
// app.use(MercurePlugin, {
//   config: {
//     hubUrl: 'https://mercure-491398758782.europe-west1.run.app/.well-known/mercure',
//     topics: [mercureTopicChannel.polRates],
//     // token: '', // Optional
//   },
// })

app.mount('#app')
